//#region src/create_user_type.ts
let CreateUserType = /* @__PURE__ */ function(CreateUserType) {
	CreateUserType["BiteAdminPortal"] = "bite-admin-portal";
	CreateUserType["InStore"] = "in-store";
	return CreateUserType;
}({});
//#endregion
export { CreateUserType };

//# sourceMappingURL=create_user_type.js.map